import { FC } from "react";
import styles from "./../styles.module.scss";

const PatientDetail: FC<{ heading: string; description: string }> = ({
  heading,
  description,
}) => {
  if (description) {
    return (
      <div className="mb-16">
        <h3 className={styles.modalSubheading}>{heading}</h3>
        <p>{description}</p>
      </div>
    );
  } else {
    return null;
  }
};

export default PatientDetail;
